/* Arissai Read More + mobile video lock + INP optimisations
   v4 — removes IO play/pause cycle on hero video (caused real-device freeze
   when scrolling up after the video had been hidden by body.hero-out-of-view).
   The browser already throttles muted/offscreen autoplay videos; no need to
   manually toggle play state on every scroll event.
*/
(function () {
  'use strict';

  function initReadMore() {
    var btns = document.querySelectorAll('.read-more-button');
    btns.forEach(function (btn) {
      if (btn.dataset.arissaiInit) return;
      btn.dataset.arissaiInit = '1';

      var content = btn.parentElement
        ? btn.parentElement.querySelector('.product-description-content')
        : null;
      if (!content) content = btn.previousElementSibling;
      if (!content) return;

      content.classList.remove('is-collapsed');

      var collapsedMax = 150;
      if (content.scrollHeight <= collapsedMax + 8) {
        btn.style.display = 'none';
        content.classList.add('expanded');
        return;
      }

      btn.textContent = 'Read More';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          var isExpanded = content.classList.toggle('expanded');
          btn.textContent = isExpanded ? 'Show Less' : 'Read More';
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        },
        { passive: false }
      );
    });
  }

  function lockHeroVideo() {
    var v = document.getElementById('arissai-hero-video');
    if (!v) return;
    v.removeAttribute('controls');
    v.setAttribute('controlslist', 'nodownload noplaybackrate nofullscreen');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.style.pointerEvents = 'none';
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function runInit() {
    initReadMore();
    lockHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(runInit, { timeout: 800 });
      } else {
        setTimeout(runInit, 1);
      }
    });
  } else {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runInit, { timeout: 800 });
    } else {
      setTimeout(runInit, 1);
    }
  }
})();

